<form [formGroup]="componentForm" class="inline-form">
  <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
       *ngIf="validationResult?.message">
    <br><br><br>
    <mat-icon color="warn">error</mat-icon><span>{{ validationResult.message }}</span>
  </div>
  <div *ngIf="!validationResult?.message">
    &nbsp;
  </div>
  <mat-form-field appearance="outline" color="accent" style="width: 100%">
    <mat-label>{{'full_name' | GetLabelPipe}}</mat-label>
    <input matInput type="text"
           (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
           formControlName="nameInput">
    <mat-error class="form-error" *ngIf="validationResult?.inputsErrors['nameInput']">{{validationResult?.inputsErrors['nameInput']}}</mat-error>
  </mat-form-field>
  <br>
  <mat-form-field appearance="outline" color="accent" style="width: 100%">
    <mat-label>{{'phone_field' | GetLabelPipe}}</mat-label>
    <input matInput type="text"
           (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
           formControlName="phoneInput">
  </mat-form-field>
  <br>
  <mat-form-field appearance="outline" color="accent" style="width: 55%">
    <mat-label>{{'birthday_field' | GetLabelPipe}}</mat-label>
    <input matInput [matDatepicker]="pickerBirthDay"
           (click)="dateInputClick($event,pickerBirthDay)"
           formControlName="birthDayInput" #birthDayInputElem>
    <mat-datepicker-toggle matSuffix [for]="pickerBirthDay"></mat-datepicker-toggle>
    <mat-datepicker touchUi startView="multi-year" [startAt]="birthDate" #pickerBirthDay></mat-datepicker>
    <mat-error class="form-error" *ngIf="validationResult?.inputsErrors['birthDayInput']">{{validationResult?.inputsErrors['birthDayInput']}}</mat-error>
  </mat-form-field>

  <div class="form-warning-text-block">
    {{'good_photo_required'|GetLabelPipe}}
  </div>

  <mat-error style="margin: 0px 30px 30px 30px; font-size: 85%;" class="form-error"
             *ngIf="picture_missing">
    {{'picture_missing'|GetLabelPipe}}
  </mat-error>

  <div class="flex-row-center flex-justify-space-around" style="width: 100%; position: relative">
    <div matRipple class="profile-right-button flex-column-center column-button"
         *ngIf="picture_src_preview"
         style="position: absolute; top: calc(5%); left: calc(3%); z-index: 1;"
         (click)="rotateImage(-90)">
      <mat-icon *ngIf="!activeRequest">rotate_right</mat-icon>
      <mat-icon *ngIf="activeRequest">hourglass_empty</mat-icon>
    </div>

    <app-quick-uploader [picture_src]="picture_src_preview" [aspect_ratio]="1.0" [self_avatar]="true"
                        (new_picture_src_ava)="picture_src_ava = $event"
                        (new_picture_src_icon)="picture_src_icon = $event"
                        (new_picture_src_preview)="picture_src_preview = $event"
                        (new_aspect_ratio)="aspect_ratio = $event"
    >
    </app-quick-uploader>

    <div matRipple class="profile-right-button flex-column-center column-button"
         *ngIf="picture_src_preview"
         style="position: absolute; top: calc(5%); left: calc(97% - 38px); z-index: 1;"
         (click)="rotateImage(90)">
      <mat-icon *ngIf="!activeRequest">rotate_left</mat-icon>
      <mat-icon *ngIf="activeRequest">hourglass_empty</mat-icon>
    </div>
  </div>

  <br>
  <br>
  <mat-checkbox class="radio-button" formControlName="tcsCheck">
    <div class="textCut" [innerHTML]="'ack_tcs' | GetLabelPipe"></div>
  </mat-checkbox>
  <mat-error style="margin: 0px 30px; font-size: 85%;" class="form-error"
             *ngIf="validationResult?.inputsErrors['tcsCheck']">
    {{validationResult?.inputsErrors['tcsCheck']}}
  </mat-error>

  <br>
  <br>
  <mat-checkbox class="radio-button" formControlName="privacyCheck">
    <div class="textCut" [innerHTML]="'ack_privacy' | GetLabelPipe"></div>
  </mat-checkbox>
  <mat-error style="margin: 0px 30px; font-size: 85%;" class="form-error"
             *ngIf="validationResult?.inputsErrors['privacyCheck']">
    {{validationResult?.inputsErrors['privacyCheck']}}
  </mat-error>

  <br>
  <br>
  <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
    <button type="submit" class="widerButton font16" mat-raised-button color="accent"
            (click)="handleSubmit()" [disabled]="this.activeRequest">
      {{'save' | GetLabelPipe}}
    </button>
  </div>
  <br>
  <br>

</form>
